<script setup>
import { computed, inject } from 'vue'
const props = defineProps(['volume', 'potentialVolume', 'comingSoon'])
const { pages, screen } = inject('Shared')
const potentialPercentage = computed(() => {
  const res = Math.round(((props.potentialVolume / (props.volume + props.potentialVolume)) * 100))
  return res <= 100 ? res : 0
})
const currentPercentage = computed(() => {
  const res = Math.round(((props.volume / (props.volume + props.potentialVolume)) * 100))
  return res <= 100 ? res : 100
})
const textColor = computed(() => {
  if (props.comingSoon) {
    return '#007BF'
  }
  if (potentialPercentage.value < 20) {
    if (pages.value && pages.value.detailReport.potentialAnalysis.progressLineFontColorLow) {
      return pages.value.detailReport.potentialAnalysis.progressLineFontColorLow
    }
    return 'white'
  } else if (potentialPercentage.value >= 20 && potentialPercentage.value <= 30) {
    if (pages.value && pages.value.detailReport.potentialAnalysis.progressLineFontColorMedium) {
      return pages.value.detailReport.potentialAnalysis.progressLineFontColorMedium
    }
    return 'white'
  }
  if (pages.value && pages.value.detailReport.potentialAnalysis.progressLineFontColorHigh) {
    return pages.value.detailReport.potentialAnalysis.progressLineFontColorHigh
  }
  return '#2E8BDF'
})
const bgColor = computed(() => {
  if (props.comingSoon) {
    return '#007BF'
  }
  if (potentialPercentage.value < 20) {
    if (pages.value && pages.value.detailReport.potentialAnalysis.progressLineBackgroundLow) {
      return pages.value.detailReport.potentialAnalysis.progressLineBackgroundLow
    }
    return '#EA604F'
  } else if (potentialPercentage.value >= 20 && potentialPercentage.value <= 30) {
    if (pages.value && pages.value.detailReport.potentialAnalysis.progressLineBackgroundMedium) {
      return pages.value.detailReport.potentialAnalysis.progressLineBackgroundMedium
    }
    return '#F6D055'
  }
  if (pages.value && pages.value.detailReport.potentialAnalysis.progressLineBackgroundHigh) {
    return pages.value.detailReport.potentialAnalysis.progressLineBackgroundHigh
  }
  return '#5FEFC0'
})

const currentScoreWidth = computed(() => {
  const res = 100 - potentialPercentage.value
  if (res < 15) {
    return 15
  }
  return res
})

</script>

<template lang='pug'>
.potentialVolumeContainer(:style="potentialPercentage > 0 ? 'background: #DCE7F2' : 'background: #EB604F'")
  .min 0%
  .max 100%
  .potentialContainer.full-width(v-if="comingSoon")
    .currentScore coming soon!
  template(v-else-if="potentialPercentage > 0")
    .currentScore(v-if="![null, undefined, NaN].includes(currentPercentage)" :style="`width: ${currentScoreWidth}%`") {{ currentPercentage }}%
    .currentScore(v-else) Unknown
    .potentialContainer(:style="`width: ${potentialPercentage ? potentialPercentage : 0}%`" v-if="![null, undefined, NaN].includes(potentialPercentage)")
      .potentialScore {{ potentialPercentage }}%
  .negativePotentialContainer(v-else)
    .row.flex-center
      .labelOne {{ screen.gt.xs ? pages.detailReport.potentialAnalysis.overUsedText : pages.detailReport.potentialAnalysis.overUsedTextMobile }}
</template>

<style scoped lang='sass'>
.potentialVolumeContainer
  width: 100%
  height: 30px
  left: 0px
  border-radius: 4px
  position: relative
  display: flex
  align-items: center
  @media screen and (min-width: 1024px)
  @media screen and (max-width: 1023px)
    margin: 8px 0 16px
  .negativePotentialContainer
    width: 100%
    height: 100%
    display: flex
    justify-content: center
    align-items: center
    background: v-bind('pages.detailReport.potentialAnalysis.overUsedBackground')
    .labelOne
      font-style: italic
      font-weight: 500
      font-size: 14px
      line-height: 130%
      color: v-bind('pages.detailReport.potentialAnalysis.overUsedColor')
    .labelTwo
      margin-left: 5px
      font-style: italic
      font-weight: 500
      font-size: 10px
      line-height: 130%
      color: v-bind('pages.detailReport.potentialAnalysis.overUsedColor')
  .min
    position: absolute
    bottom: -15px
    left: 0px
    font-weight: 600
    font-size: 10px
    line-height: 130%
    color: #626C85
  .max
    position: absolute
    bottom: -15px
    right: 0px
    font-weight: 600
    font-size: 10px
    line-height: 130%
    color: #626C85
  .potentialContainer
    height: 30px
    right: 0px
    top: 0px
    position: absolute
    background: v-bind(bgColor)
    border-radius: 4px
    display: flex
    justify-content: center
    align-items: center
    .potentialScore
      font-style: italic
      font-weight: bold
      font-size: 14px
      line-height: 130%
      color: v-bind(textColor)
      margin: 0 5px
  .currentScore
    font-weight: 500
    font-size: 14px
    line-height: 130%
    color: #626C85
    padding-right: v-bind(potentialPercentage)
    display: flex
    justify-content: center
    z-index: 1
  .levelMarker
    position: absolute
    bottom: -6px
    height: 6px
    width: 1px
    background: #626C85
    .label
      margin-top: 5px
      margin-left: -10px
      font-weight: 600
      font-size: 10px
      line-height: 130%
      color: #626C85
</style>
